
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 39 39","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.916.151S18.209 0 19.5 0s2.584.151 2.584.151l1.094 4.683c1.459.365 2.834.942 4.09 1.696l4.087-2.539s1.02.807 1.934 1.72c.913.914 1.72 1.934 1.72 1.934l-2.539 4.087a15.026 15.026 0 0 1 1.696 4.09l4.683 1.095S39 18.207 39 19.5c0 1.292-.151 2.584-.151 2.584l-4.683 1.094a15.026 15.026 0 0 1-1.696 4.09l2.538 4.087s-.806 1.02-1.72 1.934a25.47 25.47 0 0 1-1.933 1.72l-4.087-2.539a15.026 15.026 0 0 1-4.09 1.696l-1.095 4.683S20.793 39 19.5 39c-1.292 0-2.584-.151-2.584-.151l-1.094-4.683a15.026 15.026 0 0 1-4.09-1.696l-4.087 2.538s-1.02-.806-1.934-1.72c-.913-.913-1.72-1.933-1.72-1.933l2.539-4.087a15.025 15.025 0 0 1-1.696-4.09L.151 22.083S0 20.793 0 19.5c0-1.292.151-2.584.151-2.584l4.683-1.094c.365-1.459.942-2.834 1.696-4.09L3.99 7.645s.807-1.02 1.72-1.934c.914-.913 1.934-1.72 1.934-1.72l4.087 2.539a15.025 15.025 0 0 1 4.09-1.696L16.917.151Z","fill":"#00CAC1"}}),_c('path',{attrs:{"d":"M10.479 28.944A13.06 13.06 0 0 0 29.81 11.489","stroke":"#09A098","stroke-width":"5.695"}}),_c('path',{attrs:{"d":"M20.049 31.553A11.988 11.988 0 1 0 8.036 16.317","stroke":"#234652","stroke-width":".487","stroke-dasharray":"0.97 1.63"}}),_c('ellipse',{attrs:{"cx":"4.591","cy":"4.549","rx":"4.591","ry":"4.549","transform":"matrix(1 0 0 -1 14.95 24.047)","fill":"#EDF4F4"}})])
          )
        }
      }
    